"use client";

import React from "react";
import {Box, Container, Grid, Stack, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import FaIcon from "@/components/utilities/fa-icon";

const features = [
    {title: "کسب و کار ایده‌آل", faIcon: "fa-hands-helping"},
    {title: "ارسال سریع", faIcon: "fa-truck-fast"},
    {title: "کمترین قیمت", faIcon: "fa-hand-holding-usd"},
    {title: "ضمانت اصل بودن", faIcon: "fa-shield"},
];


export default function FeaturesSection() {
    const theme = useTheme();

    const Chain = () => (
        <i
            className = "fas fa-2x fa-code-commit"
            style = {{
                color: theme.palette.grey[300],
                marginBottom: 36,
                display: "flex",
                justifyContent: "center",
            }}
        />
    );

    const BulletColors = ["red", "white", "green"];

    const ColoredDots = () => (
        <>
            {BulletColors.map((color, idx) => (
                <span
                    key = {idx}
                    style = {{
                        width: 11,
                        height: 11,
                        borderRadius: "50%",
                        backgroundColor: color,
                        boxShadow: theme.shadows[2],
                        display: "inline-block",
                        marginRight: idx > 0 ? 8 : 0,
                    }}
                />
            ))}
        </>
    );

    return (
        <Box display = "flex" flexDirection = "column" alignItems = "center" width = "100%" >
            <Container
                maxWidth = "lg"
                sx = {{
                    pb: {md: 6, xs: 0},
                    px: {xs: 0, md: 3},
                    mx: 0,
                    color: "common.white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography
                    variant = "body2"
                    fontSize = {22}
                    fontWeight = {500}
                    textAlign = "center"
                    color = "primary.main"
                    mb = {1}
                    sx = {{
                        maxWidth: 850,
                    }}
                >
                    <Typography component = "span" fontSize = {26} fontWeight = {400} color = "primary.light" >
                        پیکان‌پارس
                    </Typography >
                    ، باهم پیشرفت <ColoredDots />
                </Typography >

                <Typography
                    variant = "body2"
                    textAlign = "center"
                    color = "primary.main"
                    fontSize = {16}
                    lineHeight = {1.6}
                    mb = {2}
                    maxWidth = {850}
                    display = {{xs: "none", md: "block"}}
                >
                    تهیه و توزیع هزاران محصول متنوع از معتبرترین و با اصالت‌ترین برندهای فعال در حوزه
                    <br /> لوازم یدکی خودرو، با همراهی تیمی متخصص برای ارائه خدمات فروش و پشتیبانی اینترنتی، باعث
                    شده است <br />که پیکان‌پارس به شریکی مطمئن برای کسب‌وکار شما تبدیل شود.
                </Typography >

                <Typography
                    variant = "body2"
                    textAlign = "center"
                    mb = {1.5}
                    px = {2.5}
                    fontSize = {16}
                    fontWeight = {400}
                    lineHeight = {1.6}
                    color = "primary.main"
                    maxWidth = {850}
                    display = {{md: "none", xs: "block"}}
                >
                    پیکان‌پارس با ارائه هزاران محصول معتبر در حوزه لوازم یدکی خودرو و پشتیبانی آنلاین، به شریکی
                    قابل اعتماد برای کسب‌وکار شما تبدیل شده است.
                </Typography >

                <Box
                    bgcolor = "primary.main"
                    width = "100%"
                    borderRadius = {{xs: 0, md: 2}}
                    px = {{md: 0, xs: 6}}
                >

                    <Stack
                        spacing = {4}
                        direction = {{xs: "column", md: "row"}}
                        flexWrap = {{xs: "nowrap", md: "wrap"}}
                        justifyContent = "center"
                        alignItems = "center"
                        py = {6}
                        display = {{xs: "none", md: "flex"}}
                    >
                        {features.map((feature, index) => (
                            <React.Fragment key = {feature.title} >
                                <Feature {...feature} />
                                {index !== features?.length - 1 && <Chain key = {`chain-${index}`} />}
                            </React.Fragment >
                        ))}
                    </Stack >

                    <Stack py = {5} display = {{xs: "block", md: "none"}} >
                        {features.map((feature, index) =>
                            index % 2 === 0 ? (
                                <Grid container item xs = {12} key = {feature.title} alignItems = "center"
                                    mb = {index === 0 ? 4 : 0} >
                                    <Grid item xs = {5.5} >
                                        <Feature {...feature} />
                                    </Grid >
                                    <Grid item xs = {1} display = "flex" justifyContent = "center" >
                                        {index !== features?.length - 1 && <Chain />}
                                    </Grid >
                                    <Grid item xs = {5.5} >
                                        {features[index + 1] && <Feature {...features[index + 1]} />}
                                    </Grid >
                                </Grid >
                            ) : null
                        )}
                    </Stack >
                </Box >
            </Container >
        </Box >
    );
}

const Feature = ({faIcon, title}: { faIcon: string; title: string }) => (
    <Box display = "flex" flexDirection = "column" alignItems = "center" justifyContent = "center" >
        <Box
            display = "flex"
            justifyContent = "center"
            alignItems = "center"
            borderRadius = {50}
            border = {2}
            color = "primary.light"
            width = {60}
            height = {60}
            mb = {2}
            sx = {{borderColor: "primary.light"}}
        >
            <FaIcon variant = "solid" faIcon = {`${faIcon}`} fontSize = {28} sx = {{lineHeight: 1}} />
        </Box >
        <Typography fontWeight = {300} >{title}</Typography >
    </Box >
);
